import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";


const config = {
  apiKey: "AIzaSyDjHNifMsn5Y0IPYJ2bTBnOyEziH9jlCOc",
  authDomain: "ls-dev-a8689.firebaseapp.com",
  databaseURL: "https://ls-dev-a8689-default-rtdb.firebaseio.com",
  projectId: "ls-dev-a8689",
  storageBucket: "ls-dev-a8689.appspot.com",
  messagingSenderId: "626244506266",
  appId: "1:626244506266:web:cc1c71940ed58672900523",
  measurementId: "G-33G9T57RLH"
};

firebase.initializeApp(config);

export const database = firebase.database();
export const storage = firebase.storage();
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = new firebase.auth();


export default firebase;
